<script>
import axios from 'axios'
import AclLayout from "@/js/Layouts/Acl.vue";

export default {
    name: "Permissions",
    components: { AclLayout },
    data() {
        return {
            services: []
        }
    },
    methods: {
        fetchServices() {
            axios.get('/api/get-permissions')
                .then(response => {
                    this.services = response.data
                })
                .catch(error => {
                    console.error("Ошибка при получении сервисов:", error)
                })
        },
        toggleAccess(service) {
            axios.post(`/api/change-permission-status/${service.name}/`, {
                enabled: service.status !== 'Только админам'
            })
                .then(() => {this.fetchServices()})
                .catch(error => {
                    console.error("Ошибка при обновлении доступа:", error)
                })
        }
    },
    mounted() {
        this.fetchServices()
    }
}
</script>

<template>
    <AclLayout>
        <div class="p-4">
            <h1 class="text-2xl font-bold mb-4">Изменение доступа к разделам сайта</h1>

            <table class="w-full border-collapse">
                <thead>
                <tr class="bg-gray-200 text-left">
                    <th class="p-2 border">Название</th>
                    <th class="p-2 border">Сервис</th>
                    <th class="p-2 border">Доступ</th>
                    <th class="p-2 border">Только админам</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="service in services" :key="service.name" class="hover:bg-gray-100">
                    <td class="p-2 border">{{ service.service }}</td>
                    <td class="p-2 border">{{ service.name }}</td>
                    <td class="p-2 border">{{ service.status }}</td>
                    <td class="p-2 border">
                        <label class="switch">
                            <input
                                type="checkbox"
                                :checked="service.status === 'Только админ'"
                                @change="toggleAccess(service)"
                            >
                            <span class="slider"></span>
                        </label>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </AclLayout>
</template>

<style scoped>
table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

th, td {
    border: 1px solid #ccc;
    padding: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 25%;
}

.switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0;
    right: 0; bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 24px;
}

.slider::before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

input:checked + .slider {
    background-color: #4CAF50;
}

input:checked + .slider::before {
    transform: translateX(24px);
}
</style>
